<template>
  <div class="page" >
    <div class="connected">
      <div class="connected-left">
        <div class="connected-left-touch">CONTACT US</div>
        <div class="connected-left-message">
          <div>Telegram: @yuliverseofficialsupport</div>
          <div>
            Email: support@yuliverse.com &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            partnership@yuliverse.com
          </div>
        </div>
      </div>
      <div class="connected-right">
        <div class="connected-right-stay">Stay connected:</div>
        <div class="connected-right-link">
          <a href="http://twitter.com/TheYuliverse" target="_blank"
            ><img
              :src="
                oneImg
                  ? iconData[2].imgUrl
                  : require('@/assets/images/YuliApp/main/icon_twitte.png')
              "
              @mouseenter="handleImg(3)"
              @mouseleave="handleImgOVer(3)"
          /></a>

          <a href="http://t.me/YuliverseOfficial" target="_blank"
            ><img
              :src="
                twoImg
                  ? iconData[1].imgUrl
                  : require('@/assets/images/YuliApp/main/icon_telegram@2x.png')
              "
              @mouseenter="handleImg(4)"
              @mouseleave="handleImgOVer(4)"
          /></a>
          <a href="http://discord.gg/Yuliverseofficial" target="_blank"
            ><img
              :src="
                threeImg
                  ? iconData[0].imgUrl
                  : require('@/assets/images/YuliApp/main/icon_discord@2x.png')
              "
              @mouseenter="handleImg(5)"
              @mouseleave="handleImgOVer(5)"
          /></a>
        </div>
        <div class="connected-right-logo">
          <img
            class="connected-right-logo-img"
            :src="require('@/assets/images/YuliApp/main/logomin.png')"
          />
          <div>@2022.yuliverse</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "YuliConnect",
  data() {
    return {
      iconData: [
        {
          imgUrl: require("@/assets/images/YuliApp/main/icon_discord_selet@2x.png"),
        },
        {
          imgUrl: require("@/assets/images/YuliApp/main/icon_telegram_selet@2x.png"),
        },
        {
          imgUrl: require("@/assets/images/YuliApp/main/icon_twitte_selet@2x.png"),
        },
      ],
      oneImg: false,
      twoImg: false,
      threeImg: false,
    };
  },
  methods: {
    handleImg(index) {
      if (index === 3) {
        this.oneImg = true;
      }
      if (index === 4) {
        this.twoImg = true;
      }
      if (index === 5) {
        this.threeImg = true;
      }
    },
    handleImgOVer(index) {
      if (index === 3) {
        this.oneImg = false;
      }
      if (index === 4) {
        this.twoImg = false;
      }
      if (index === 5) {
        this.threeImg = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: "Josefin Sans";
  background-color: black;
  // background-image: url("~@/assets/images/bg/bg_11.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 367px;
  .connected {
    width: 1144.39px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 100px;
    &-left {
      &-contact,
      &-message {
        color: rgba(255, 255, 255, 1);
        font-size: 15px;
        font-weight: 400;
        font-family: "Josefin Sans";
        text-align: left;
      }
      &-contact {
        margin-top: 20.7px;
      }
      &-message {
        line-height: 22px;
      }
      &-touch {
        height: 68px;
        line-height: 68px;
        color: rgba(255, 255, 255, 1);
        font-size: 45px;
        font-weight: 700;
        font-family: "Josefin Sans";
        text-align: left;
        margin-bottom: 8.29px;
        margin-top: 62px;
      }
    }
    &-right {
      &-stay {
        color: rgba(255, 255, 255, 1);
        font-size: 15px;
        font-weight: 400;
        font-family: "Josefin Sans";
        text-align: left;
        margin-top: 62px;
        margin-bottom: 18px;
      }
      &-link {
        img {
          display: inline-block;
          font-size: 0;
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
      }
      &-logo {
        margin-top: 24px;
        display: flex;
        align-items: flex-end;
        color: #999999;
        font-size: 14px;
        font-weight: 500;
        &-img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
